module.exports = __webpack_public_path__ + "static/img/ISBNshuhao.aa2fbfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ISBNshuhao.png
// module id = +Pc6
// module chunks = 18